import React from 'react'
import style from './headerMenu.module.css'
import { NavLink } from 'react-router-dom'

interface MenuProps {
	menu?: Menu
}

interface MenuItem {
	name: string,
	link: string
}

interface Menu extends Array<MenuItem>{};
const HeaderMenu: React.FC<MenuProps> = ({ menu }) => {
	return (
		<ul className={style.header_menu}>
			{menu && menu.map((item, index) => (
				<li key={index}>
					<NavLink
						className={({ isActive }) =>
							isActive ? style.header_menu__active_item : style.header_menu__item
						}
						to={item.link}
						end
					>
						{item.name}
					</NavLink>
				</li>
			))}
		</ul>

	)
}
export default HeaderMenu
